import React, { useEffect, useState } from "react";
import { Formik, useFormikContext } from "formik";

import { useDispatch, useSelector } from "react-redux";
import { updateInitialProfile } from "../../../services/profile";
import { setLoading } from "../../../reducer/auth/auth";
import Select from "react-select";
import PreferredLanguageSelect, { preferredLanguageOrDefault } from "../../../components/preferredLanguageSelect";

import {
  capatilizeLetter,
  filterVisibleTimeZones,
  filterZone,
  screenNameHandler,
} from "../../../utils/helpers";
import PhoneInputField from "../../../components/Inputfields/phoneinput";
import moment from "moment-timezone";
import TimeZoneCofirmPopup from "../../profile/timeZoneConfirmPopup";
import TimeZonePopup from "../../profile/timeZonePopup";
import CountryTimeZoneSelection from "../../profile/countryTimeZoneSelection";
import { getTimeZoneFromCountry } from "../../../services/auth";
import { useTranslation } from "react-i18next";

const StepOne = (props) => {
  const { t } = useTranslation("clientProfile");
  const {

    timezone_name
  } = useSelector((state) => state.user.user);
  const [newformData, setNewFormData] = useState([]);
  const [newCountryData, setNewCountryData] = useState([]);
  const [newTimezoneData, setNewTimezoneData] = useState([]);
  const [userCountryCode, setUserCountryCode] = useState("US");
  const [showExpectionInfo, setshowExpectionInfo] = useState(false);
  const [timeZoneError, setTimeZoneError] = useState(false);
  const [CurrentDate, setCurrentDate] = useState(moment().format('hh:mm A'))
  const [temporaryStorage, setTemporaryStorage] = useState({});
  const [disableTime, setDisableTime] = useState('');
  const [countryName, setcountryName] = useState('');
  const {
    NextStep,
    stepOneData,
    setValues,
    formLanguages,
    specialtyData,
    countryData,
    countryOnly,
    timezoneData,
    timezoneOnly,
  } = props;
  //new
  const [countrySpecifiedTimeZone, setCountrySpecifiedTimeZone] = useState([

  ]);

  const usTimeZones =
    ["(GMT-5:00) Eastern Standard Time - New York",
      "(GMT-5:00) Eastern Standard Time - East-Indiana",
      "(GMT-6:00) Central Standard Time - Chicago",
      "(GMT-9:00) Alaska Standard Time - Alaska",
      "(GMT-10:00) Hawaii Standard Time - Honolulu",
      "(GMT-11:00) Samoa Standard Time - Midway",
      "(GMT-06:00) Central Standard Time - Chicago",
      "(GMT-05:00) Eastern Standard Time - New_York"
    ]
  const canadaTimeZones = ["(GMT-3:30) Newfoundland Standard Time - Newfoundland",
    "(GMT-4:00) Atlantic Standard Time - Atlantic",
    "(GMT-5:00) Eastern Standard Time - New York",
    "(GMT-6:00) Central Standard Time - Saskatchewan",
    "(GMT-6:00) Central Standard Time - Chicago",
    "(GMT-06:00) Central Standard Time - Chicago",
  ]
  //new
  const dispatch = useDispatch();

  useEffect(() => {
    setNewFormData(
      formLanguages.map((item) => {
        return {
          ...item,
          value: item.id,
          label: item.name,
        };
      })
    );
    setNewTimezoneData(filterVisibleTimeZones(timezoneData));
    setNewCountryData(
      countryData.map((item) => {
        console.log(item, "item")
        return {
          ...item,
          value: item.id,
          label: item.country_name,
          country_code: item.country_code,
          dot_name: item.country_code.split("").join("."),
          updatedName: item.country_name == "United States" ? 'USA':  item.country_name
            .split(" ")
            .map(word => word.charAt(0))
            .join(""),
          updatedDotName: item.country_name == "United States" ? 'U.S.A.' : item.country_name
            .split(" ")
            .map(word => word.charAt(0))
            .join(".").concat("."),

        };
      })
    );
    addDefault();
  }, ["", formLanguages, specialtyData, countryData, timezoneData]);

  const addDefault = () => {
    if (!stepOneData.languages.length > 0 && newformData.length) {
      stepOneData.languages.push(newformData[10]);
    }
  };

  const RunFunction = (formData) => {
    setValues(formData, 1);

    const {
      first_name,
      last_name,
      phone,
      whatsapp,
      languages,
      country,
      screen_name,
      timezone,
    } = formData;

    // if (timezone.id === "" && timezone.name === "") {

    //   dispatch(setLoading(false));
    //   setTimeZoneError(true)
    //   return;

    // }
    let lang = languages.map((item) => {
      return item.id;
    });
    let timezones =
      timezone.id === "" ? filterZone(timezone, timezoneData) : timezone.id;

    let item = {
      first_name: first_name,
      last_name: last_name,
      phone: phone,
      whatsapp: whatsapp,
      country: country.label !== undefined ? country.label : country,
      languages: lang,
      preferred_communication_language: preferredLanguageOrDefault(formData.preferred_communication_language),
      timezone: timezones,
      screen_name: screen_name,
    };
    //new
    let countrycheck = country.label !== undefined ? country.label : country;
    let countryLabel = countryData.filter(
      (item) => item.country_name == countrycheck
    );
    console.log(countryLabel, "countryLabel", countryData, countrycheck);
    setcountryName(countrycheck)

    // console.log("United States","country" "Canada");
    //new
    let newTimeZone = timezone.name !== undefined ? timezone.name : timezone_name
    if (newTimeZone == "US/Arizona") {
      setDisableTime(newTimeZone)
      window.loadModal2('#TimeZoneCofirmPopup', 'show');
      setTemporaryStorage(item);
      return;
    }
    if (newTimeZone === "US/Mountain" || newTimeZone === "America/Los_Angeles") {
      setTemporaryStorage(item);
      const check = phone.slice(0, 4);
      console.log(check, "check")
      let array = [1623, 1480, 1520, 1867]
      if (array.includes(parseInt(check))) {
        setDisableTime('US/Arizona')
        window.loadModal2('#TimeZoneCofirmPopup', 'show');
        return;
      } else {

        window.loadModal2('#TimeZonePopup', 'show');
        return;
      }

    }
    console.log(timezone.front_name, timezone.front_name, "usTimeZones", usTimeZones, "countrycheck", countrycheck)
    // if (countrycheck == "United States") {
    if (countrycheck == "United States" && !usTimeZones.includes(timezone.front_name)) {
      window.loadModal2("#CountryTimeZoneSelection", "show");
      setTemporaryStorage(item);
      getTimeZoneFromCountry(countryLabel[0].country_code)
        .then((data) => {
          if (data.data.status) {
            setCountrySpecifiedTimeZone(data.data.data);
          }
        })
        .catch(() => { });
      return;
    }
    // if (countrycheck == "Canada") {
    if (countrycheck == "Canada" && !canadaTimeZones.includes(timezone.front_name)) {
      window.loadModal2("#CountryTimeZoneSelection", "show");
      setTemporaryStorage(item);
      getTimeZoneFromCountry(countryLabel[0].country_code)
        .then((data) => {
          if (data.data.status) {
            setCountrySpecifiedTimeZone(data.data.data);
          }
        })
        .catch(() => { });
      return;
    }

    dispatch(setLoading(true));
    setDisableTime('')
    updateInitialProfile(item)
      .then((data) => {
        dispatch(setLoading(false));
        if (data.data.status) {
          NextStep();
        }
      })
      .catch((err) => {
        dispatch(setLoading(false));
        console.log(err);
      });
  };
  const customHandleChange = (errors) => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  const capatilizeLetters = (e, name, setFieldValue, uservalues) => {
    let values = e.target.value;
    const input = capatilizeLetter(values);
    setFieldValue(name, input);

    if (uservalues.first_name !== "") {
      console.log(
        screenNameHandler(uservalues.first_name, uservalues.last_name)
      );
      setFieldValue(
        "screen_name",
        screenNameHandler(
          name === "first_name" ? e.target.value : uservalues.first_name,
          name === "last_name" ? e.target.value : uservalues.last_name
        )
      );
    }
    if (e.target.name === "first_name" && e.target.value === "") {
      setFieldValue("screen_name", "");
    }
  };
  const countryChangeHandler = (value, name, setFieldValue) => {
    setUserCountryCode(value.country_code);
    setFieldValue(name, value);
  };
  // const checkTat = () => {
  //   console.log(timezoneData, "timezoneData")
  //   let timezone = stepOneData.timezone;
  //   let check = timezoneData.filter((time) => time.name === timezone.name);
  //   if (check.length) {
  //     return
  //   } else {
  //     stepOneData.timezone = { id: '', name: '' }
  //     // setTimeZoneError(true)
  //   }


  // }
  //
  const confirmRequest = (values) => {
    let value = values == "" ? temporaryStorage : values;
    window.loadModal2('#TimeZonePopup', 'hide');
    window.loadModal2("#CountryTimeZoneSelection", "hide");
    console.log(value);
    dispatch(setLoading(true));
    updateInitialProfile(value)
      .then((data) => {
        dispatch(setLoading(false));
        if (data.data.status) {


          NextStep();
        }
      })
      .catch((err) => {
        dispatch(setLoading(false));
        console.log(err);
      });
  }
  const cancelRequest = () => {
    window.loadModal2('#TimeZoneCofirmPopup', 'hide');
    window.loadModal2('#TimeZonePopup', 'show');
  }

  const confirmNewTimeZone = (value) => {
    console.log(temporaryStorage, "temporaryStorage", value);

    let newValue = {
      ...temporaryStorage,
      timezone: parseInt(value),
    }
    console.log(newValue, newValue)
    confirmRequest(newValue)
  }
  //
  const changeTimeZone = (setFieldValue, value) => {
    setFieldValue("timezone", value)
    setCurrentDate(moment().tz(value.name).format('hh:mm A'))
  }
  const customFilter = (option, inputValue) => {
    console.log(option, inputValue)

    if (!inputValue) return true; // Show all options if input is empty

    const label = option.label.toLowerCase();
    const input = inputValue.toLowerCase();
    const country_code = option.data.country_code.toLowerCase();
    const dot_name = option.data.dot_name.toLowerCase();
    const updatedDotName = option.data.updatedDotName.toLowerCase();
    const updatedName = option.data.updatedName.toLowerCase();

    // Match criteria: Start with, Includes, Ends with
    return label.startsWith(input)   ||
      country_code.startsWith(input) || country_code.includes(input) || country_code.endsWith(input) ||
      dot_name.startsWith(input) || dot_name.includes(input) || dot_name.endsWith(input) ||
      updatedDotName.startsWith(input) || updatedDotName.includes(input) || updatedDotName.endsWith(input) ||
      updatedName.startsWith(input) || updatedName.includes(input) || updatedName.endsWith(input)
      ;
  };

 const FormikAutoSelect = ({ newTimezoneData, newformData, setCurrentDate }) => {
  const { values, setFieldValue } = useFormikContext();

  useEffect(() => {
    // 1. Auto-select Languages if the array is empty
    if (newformData && newformData.length > 0 && values.languages.length === 0) {
      // Auto-select the 11th item as per your logic (index 10)
      const defaultLang = newformData[10] || newformData[0];
      setFieldValue("languages", [defaultLang]);
    }

    // 2. Auto-detect Timezone logic
    if (newTimezoneData && newTimezoneData.length > 0) {
      const isTimezoneMissing = !values.timezone || !values.timezone.id || values.timezone.id === "";

      if (isTimezoneMissing) {
        try {
          const browserTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
          const normalizeTimezoneValue = (value = "") =>
            value.toLowerCase().replace(/[_\s-]/g, "");
          const browserTzParts = browserTz.split("/");
          const browserTzCity = browserTzParts[browserTzParts.length - 1] || "";
          const normalizedBrowserTz = normalizeTimezoneValue(browserTz);
          const normalizedBrowserTzCity = normalizeTimezoneValue(browserTzCity);

          const matchingTimezone =
            newTimezoneData.find((tz) => tz.name === browserTz) ||
            newTimezoneData.find((tz) =>
              tz.name && normalizeTimezoneValue(tz.name) === normalizedBrowserTz
            ) ||
            newTimezoneData.find((tz) => {
              const timezoneCity = tz.name ? tz.name.split("/").pop() : "";
              const frontName = tz.front_name || tz.label || "";

              return (
                normalizeTimezoneValue(timezoneCity) === normalizedBrowserTzCity ||
                normalizeTimezoneValue(frontName).includes(normalizedBrowserTzCity)
              );
            });

          if (matchingTimezone) {
            setFieldValue("timezone", matchingTimezone);
            setCurrentDate(moment().tz(matchingTimezone.name).format('hh:mm A'));
          }
        } catch (err) {
          console.error("Auto-detect timezone failed:", err);
        }
      } else {
        // SYNC: Ensure dropdown displays the correctly mapped object
        const syncTimezone = newTimezoneData.find((tz) => tz.id === values.timezone.id);
        if (syncTimezone && values.timezone !== syncTimezone) {
          setFieldValue("timezone", syncTimezone);
        }
      }
    }
  }, [newTimezoneData, newformData, setFieldValue]); // Added newformData to dependencies

  return null;
};

  return (
    <>
      <Formik
      enableReinitialize={true}
        initialValues={stepOneData}
        validate={(values) => {
          const errors = {};
          if (!values.timeconfirmcheck) errors.timeconfirmcheck = t("common:validation.required");
          if (!values.first_name) errors.first_name = t("common:validation.required");
          if (!values.last_name) errors.last_name = t("common:validation.required");
          if (!values.languages.length) errors.languages = t("common:validation.required");
          if (values.whatsapp && values.whatsapp.length < 10) {
            errors.whatsapp = t("stepOne.invalidWhatsapp");
          }
          if (!values.screen_name) errors.screen_name = t("common:validation.required");
          if (!values.phone) {
            errors.phone = t("common:validation.required");
          }
          if (values.phone && values.phone.length < 10) {
            errors.phone = t("stepOne.invalidPhone");
          }
          if (!values.country) errors.country = t("common:validation.required");
          if (!values.timezone.id) errors.timezone = t("common:validation.required");
          return errors;
        }}
        onSubmit={(values, { setSubmitting }) => {
          RunFunction(values);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          setFieldValue,
          handleSubmit,
        }) => (

          <form onSubmit={handleSubmit}>
            <FormikAutoSelect 
  newTimezoneData={newTimezoneData} 
  newformData={newformData} 
  setCurrentDate={setCurrentDate} 
/>
            {addDefault()}
            {/* {checkTat()} */}
            <div className="from-inner-box">
              <div className="left-side">
                <label>
                  {t("stepOne.firstName")}<i>*</i>
                </label>
                <input
                  onChange={(e) =>
                    capatilizeLetters(e, "first_name", setFieldValue, values)
                  }
                  className={`${errors.first_name && touched.first_name && errors.first_name
                    ? "error-boundry"
                    : ""
                    }`}
                  onBlur={handleBlur}
                  value={values.first_name}
                  type="text"
                  id="first_name"
                  name="first_name"
                  placeholder={t("stepOne.firstName")}
                />
              </div>
              <div className="right-side">
                <label>
                  {t("stepOne.lastName")}<i>*</i>
                </label>
                <input
                  className={`${errors.last_name && touched.last_name && errors.last_name
                    ? "error-boundry"
                    : ""
                    }`}
                  onChange={(e) =>
                    capatilizeLetters(e, "last_name", setFieldValue, values)
                  }
                  onBlur={handleBlur}
                  value={values.last_name}
                  type="text"
                  id="last_name"
                  name="last_name"
                  placeholder={t("stepOne.lastName")}
                />
              </div>
            </div>
            <div className="from-inner-box cuntrey-website">
              <div>
                <label>
                  {t("stepOne.country")} <i>*</i>
                </label>
                {countryOnly && (
                  <Select
                    id="country"
                    className="selection-box CreateNewAppointmentVal"
                    options={newCountryData}
                    defaultInputValue={
                      typeof values.country == "object"
                        ? values.country.country_name
                        : values.country
                    }
                    onChange={(value) =>
                      countryChangeHandler(value, "country", setFieldValue)
                    }
                    filterOption={customFilter}
                    onBlur={handleBlur}
                    placeholder={t("stepOne.countryPlaceholder")}
                    value={values.country}
                    closeMenuOnSelect={true}
                    closeMenuOnScroll={true}
                  />
                )}
                {countryOnly == null && (
                  <Select
                    id="country"
                    className="selection-box CreateNewAppointmentVal"
                    options={newCountryData}
                    onChange={(value) =>
                      countryChangeHandler(value, "country", setFieldValue)
                    }
                    filterOption={customFilter}
                    onBlur={handleBlur}
                    placeholder={t("stepOne.countryPlaceholder")}
                    value={values.country}
                    closeMenuOnSelect={true}
                    closeMenuOnScroll={true}
                  />
                )}
                <span className="error">
                  {errors.country && touched.country && errors.country}
                </span>
              </div>
            </div>
            {/* {getFirstWordString(values.country)} */}
            <div className="from-inner-box">
              {" "}
              <div className="left-side">
                <label>
                  {t("stepOne.phone")}{" "}<i>*</i>
                  <span className="font-size-11">
                    {/* (optional for text reminders) */}
                  </span>
                </label>
                <PhoneInputField
                  className={`number-input ${errors.phone && touched.phone && errors.phone
                    ? "error-boundry"
                    : ""
                    }`}
                  country={userCountryCode.toLowerCase()}
                  setFieldValue={setFieldValue}
                  onBlur={handleBlur}
                  value={values.phone}
                  id="phone"
                  name="phone"
                />
                <span className="error">
                  {errors.phone && touched.phone && errors.phone}
                </span>
              </div>
              <div className="right-side">
                <label>{t("stepOne.whatsapp")}</label>
                <PhoneInputField
                  className={`number-input ${errors.whatsapp && touched.whatsapp && errors.whatsapp
                    ? "error-boundry"
                    : ""
                    }`}
                  country={userCountryCode.toLowerCase()}
                  setFieldValue={setFieldValue}
                  onBlur={handleBlur}
                  value={values.whatsapp}
                  id="whatsapp"
                  name="whatsapp"
                />
                {/* <input
                className={`${
                  errors.whatsapp && touched.whatsapp && errors.whatsapp
                    ? "error-boundry"
                    : ""
                }`}
                onChange={(e) =>
                  handleChangeHandler(e, "whatsapp", setFieldValue)
                }
                onBlur={handleBlur}
                value={values.whatsapp}
                maxlength="10"
                pattern="\d{10}"
                id="whatsapp"
                name="whatsapp"
                placeholder=""
                type="tel"
              /> */}
                <span className="error">
                  {errors.whatsapp && touched.whatsapp && errors.whatsapp}
                </span>
              </div>
            </div>

            <div className="from-inner-box">
              <div className="full-fild">
                <label>
                  {t("stepOne.languages")}<i>*</i>
                </label>
                <Select
                  id="languages"
                  className="selection-box"
                  options={newformData}
                  multi={true}
                  isMulti
                  onChange={(value) => setFieldValue("languages", value)}
                  onBlur={handleBlur}
                  placeholder={t("stepOne.selectLanguages")}
                  value={values.languages}
                  closeMenuOnSelect={false}
                  closeMenuOnScroll={false}
                />

                <span className="error">
                  {errors.languages && touched.languages && errors.languages}
                </span>
              </div>
            </div>
            <div className="from-inner-box">
              <div className="full-fild">
                <label>
                  {t("common:common.preferredCommunication")}<i>*</i>
                </label>
                <PreferredLanguageSelect
                  value={preferredLanguageOrDefault(values.preferred_communication_language)}
                  onChange={(code) => setFieldValue("preferred_communication_language", code)}
                  onBlur={handleBlur}
                />
              </div>
            </div>
            <div className="from-inner-box search-name">
              <label>
                {t("stepOne.screenName")} <i>*</i>
              </label>
              <input
                className={`${errors.screen_name && touched.screen_name && errors.screen_name
                  ? "error-boundry"
                  : ""
                  }`}
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.screen_name}
                id="screen_name"
                name="screen_name"
                type="text"
                placeholder={t("stepOne.screenName")}
              />
              <h6>
                {t("stepOne.screenNameInfo")}
                <span className="text-decoration-underline pointer" onClick={() => setshowExpectionInfo(!showExpectionInfo)}>
                  {t("stepOne.theseExceptions")}
                </span>
              </h6>
              {showExpectionInfo && (
                <span className="showexpectioninfo">
                  <br />
                  <span className="d-block text-left">{t("stepOne.exceptions")}</span>
                  <ol>
                    <li>
                      {t("stepOne.exceptionPhone")}
                    </li>
                    <li>
                      {t("stepOne.exceptionPayment")}
                    </li>
                  </ol>
                  <span className="d-block text-left">{t("stepOne.exceptionNoMarketing")}
                  </span>
                </span>
              )}
            </div>

            <div className="from-inner-box cuntrey-website">
              <label>
                {t("stepOne.timezone")}<i>*</i>
              </label>

              {timezoneOnly && (
                <Select
                  id="timezone"
                  className="selection-box"
                  options={newTimezoneData}
                  defaultValue={values.timezone}
                  defaultInputValue={values.timezone.front_name}
                  onChange={(value) => changeTimeZone(setFieldValue, value)}
                  onBlur={handleBlur}
                  placeholder={t("stepOne.selectTimezone")}
                  value={values.timezone}
                  closeMenuOnSelect={true}
                  closeMenuOnScroll={true}
                />
              )}
              {timezoneOnly === null && (
                <Select
                  id="timezone"
                  className="selection-box"
                  options={newTimezoneData}
                  defaultValue={values.timezone}
                  defaultInputValue={values.timezone.front_name}
                  onChange={(value) => changeTimeZone(setFieldValue, value)}
                  onBlur={handleBlur}
                  placeholder={t("stepOne.selectTimezone")}
                  value={values.timezone}
                  closeMenuOnSelect={true}
                  closeMenuOnScroll={true}
                />
              )}

              <span className="error mt-1">
                {errors.timezone && touched.timezone && errors.timezone}

              </span>
              <h6 className="mt-3 text-left">   {t("stepOne.currentTime")} <b className="red font-size-18">{CurrentDate}</b></h6>
              <div className="full-fild">

                <div className="prvacy-box eth-pri">
                  <input
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value="The time above is my correct time"
                    id="timeconfirmcheck"
                    type="checkbox"
                    name="timeconfirmcheck"
                    defaultChecked={
                      values.timeconfirmcheck ===
                        "The time above is my correct time"
                        ? true
                        : false
                    }
                    className="pointer"
                  />
                  <label htmlFor="timeconfirmcheck">
                    {t("stepOne.timeConfirm")}
                  </label>
                  <span className="error">
                    {errors.timeconfirmcheck &&
                      touched.timeconfirmcheck &&
                      errors.timeconfirmcheck}
                    {/* {!values.timeconfirmcheck && showRequiredError ? 'Required' : ''} */}
                  </span>
                </div>
              </div>
            </div>

            <button
              onClick={() => customHandleChange(errors)}
              type="submit"
              className="next action-button"
            // value="Next"
            >
              {t("stepOne.next")}
            </button>
          </form>
        )}
      </Formik>
      <TimeZoneCofirmPopup confirmRequest={confirmRequest} cancelRequest={cancelRequest} id={"TimeZoneCofirmPopup"} />
      <TimeZonePopup newTimezoneData={newTimezoneData} confirmNewTimeZone={confirmNewTimeZone} disableTime={disableTime} CurrentDate={CurrentDate} />
      <CountryTimeZoneSelection
        confirmNewTimeZone={confirmNewTimeZone}
        newTimezoneData={countrySpecifiedTimeZone}
        CurrentDate={CurrentDate}
        countryName={countryName}
      />
    </>
  );
};
export default StepOne;
